import { StateConfig, useMultiState } from '@common/hooks';
import { useLogout } from '@common/hooks/useLogout';
import { MixerHorizontalIcon, RocketIcon } from '@radix-ui/react-icons';
import { Box, Button, Text } from '@radix-ui/themes';
import {
    EndpointTypes,
    // ENV,
    getStoredEnvironment,
    setEnvironment,
} from '@services';

const ENV_CONFIG: StateConfig<EndpointTypes> = {
    [EndpointTypes.LABS]: {
        label: 'Labs',
        icon: MixerHorizontalIcon,
        color: 'orange',
    },
    [EndpointTypes.PROD]: {
        label: 'Production',
        icon: RocketIcon,
        color: 'green',
    },
};

export const EnvSwitcher = () => {
    const { handleLogout, isLoading } = useLogout();

    const {
        state,
        Icon,
        buttonProps,
        label: _,
    } = useMultiState({
        states: ENV_CONFIG,
        initialState: getStoredEnvironment(),
        order: [EndpointTypes.LABS, EndpointTypes.PROD],
        onChange: async (next) => {
            await handleLogout();
            setEnvironment(next);
        },
    });

    //! TODO: DISABLE THIS BACK WHEN METRICS ARE AVAILABLE IN PROD ENV
    // if (!ENV.isDevelopment()) return null;

    return (
        <Box>
            <Button
                {...buttonProps}
                variant='soft'
                size='2'
                loading={isLoading}
            >
                {Icon && <Icon />}
                <Text size='1' weight='bold'>
                    {state.toUpperCase()}
                </Text>
            </Button>
        </Box>
    );
};
